// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__MJR7C","info":"PatientInfo_info__28rsI"};